<template>
    <div class="naGrid">
        <div class="naHeader">
            <div class="naHead">Changelog</div>

            <div class="naTopControls">
                <div class="na-FilterCell">
                    <label>Days Back:</label>
                    <DxSelectBox :items="daysBackOptions"
                                 :value="selectedDaysBack"
                                 @value-changed="onDaysBackChanged"
                                 display-expr="text"
                                 value-expr="value"
                                 width="120" />
                </div>
                <div class="na-FilterCell">
                    <label>Linked Topics:</label>
                    <DxSwitch v-model:value="isTlt"
                              switchedOffText="" 
                              switchedOnText="" 
                              @value-changed="onTltChanged"
                              width="30" />
                </div>
                <div>
                    <DxButton icon="refresh"
                              type="text"
                              @click="loadData"
                              :disabled="loading" />
                </div>
            </div>
        </div>

        <div class="na-list">
            <DxDataGrid :data-source="topicChanges"
                        :show-borders="true"
                        key-expr="TopicID"
                        :loading="loading"
                        hoverStateEnabled="true">
                <DxColumn caption="Actions"
                          width="80"
                          alignment="center"
                          cell-template="actionTemplate" />
                <DxColumn data-field="TopicID"
                          caption="ID"
                          width="80"
                          alignment="center" />
                <DxColumn data-field="Title"
                          caption="Title"
                          cell-template="titleTemplate" />
                <DxColumn data-field="Title2"
                          caption="Linked with Topic"
                          :visible="isTlt" />
                <DxColumn data-field="ChangedBy" caption="Changed By" width="120" />
                <DxColumn data-field="ChangedOn"
                          caption="Changed On"
                          data-type="datetime"
                          format="dd.MM.yyyy HH:mm"
                          width="80" />
                <DxColumn data-field="CreatedBy" caption="Created By" width="120" />
                <DxColumn data-field="CreatedOn"
                          caption="Created On"
                          data-type="datetime"
                          format="dd.MM.yyyy HH:mm"
                          width="80" />
                <DxColumn data-field="TtyName"
                          caption="Type"
                          width="80"
                          alignment="center" />

                <template #titleTemplate="{ data }">
                    <div class="title-cell">
                        {{ data.value }}
                    </div>
                </template>

                <template #actionTemplate="{ data }">
                    <div class="pqMenuBtn">
                        <DxButton icon="fas fa-pen"
                                  hint="Edit Topic"
                                  class="pqBtn"
                                  @click="editTopic(data.data)" />
                    </div>
                </template>

                <DxPaging :page-size="20" />
                <DxPager :show-page-size-selector="true"
                         :allowed-page-sizes="[10, 20, 50]"
                         :show-navigation-buttons="true"
                         :show-info="true" />

                <DxColumnChooser :enabled="true" :allow-search="true" mode="select" />
                <DxColumnFixing :enabled="true" />
                <DxFilterPanel :visible="true" />
                <DxFilterRow :visible="true" />
                <DxHeaderFilter :visible="true" />
                <DxSearchPanel :visible="true" placeholder="Search ..." />
                <DxLoadPanel :enabled="false" />
                <DxScrolling row-rendering-mode="standard" />
                <DxPaging :page-size="15" />
                <DxPager :visible="true"
                         :show-page-size-selector="true"
                         :allowed-page-sizes="[10, 15, 30]"
                         :show-info="true"
                         :show-navigation-buttons="true" />
                <DxSorting mode="multiple" />
                <DxGroupPanel :visible="true" />
                <DxStateStoring :enabled="true"
                                :customLoad="loadState"
                                :customSave="saveState"
                                :storage-key="storageKey" />
                <DxExport :enabled="true" :allow-export-selected-data="true" />
            </DxDataGrid>
        </div>

        <div class="widget-footer" v-if="message">
            <small class="text-muted">{{ message }}</small>
        </div>
    </div>
</template>

<script>
    import {
        DxDataGrid,
        DxColumn,
        DxColumnChooser,
        DxColumnFixing,
        DxFilterRow,
        DxHeaderFilter,
        DxSearchPanel,
        DxLoadPanel,
        DxScrolling,
        DxSorting,
        DxPaging,
        DxPager,
        DxFilterPanel,
        DxStateStoring,
        DxGroupPanel,
        DxExport,
    } from "devextreme-vue/data-grid";
    import { DxButton } from "devextreme-vue/button";
    import { DxSelectBox } from "devextreme-vue/select-box";
    import { DxSwitch } from "devextreme-vue/switch";

    export default {
        name: "RecentChangedTopics",
        components: {
            DxDataGrid,
            DxColumn,
            DxColumnChooser,
            DxColumnFixing,
            DxFilterRow,
            DxHeaderFilter,
            DxSearchPanel,
            DxLoadPanel,
            DxScrolling,
            DxSorting,
            DxPaging,
            DxPager,
            DxFilterPanel,
            DxStateStoring,
            DxGroupPanel,
            DxExport,
            DxButton,
            DxSelectBox,
            DxSwitch,
        },
        data() {
            return {
                isTlt: false,
                selectedDaysBack: 14,
                daysBackOptions: [
                    { value: 7, text: "7 days" },
                    { value: 14, text: "14 days" },
                    { value: 30, text: "30 days" },
                    { value: 60, text: "60 days" },
                    { value: 90, text: "90 days" },
                ],
                loading: false,
            };
        },
        computed: {
            topicChanges() {
                var result = this.$store.state.applicationStore.recentTopicChanges;
                return result || [];
            },
            message() {
                var result = this.$store.state.applicationStore.recentTopicChangesMessage;
                return result || "";
            },
            storageKey: function () {
                return "RecentChangedTopicsWidget_Storage";
            },
        },
        mounted() {
            this.loadData();
        },
        methods: {
            async loadData() {
               
                this.loading = true;
                try {
                    await this.$store.dispatch("GetRecentTopicChanges", {
                        daysBack: this.selectedDaysBack,
                        isTlt: this.isTlt
                    });
                } catch (error) {
                    console.error("Error loading recent topic changes:", error);
                } finally {
                    this.loading = false;
                }
            },
            onDaysBackChanged(e) {
                this.selectedDaysBack = e.value;
                this.loadData();
            },
            onTltChanged(e) {
                this.isTlt = e.value;
                this.loadData();
            },
            editTopic(topic) {
                window.LoadPanel.Show();

                var topicList = JSON.stringify(this.topicChanges.map(r => r.TopicID));

                var data = {
                    action: "edit",
                    id: topic.TopicID,
                    list: topicList
                };
                var url = window.location.pathname
                window.post(url, data)
                console.log("Posting to DashboardAdmin with data:", data);
                window.post(url, data);
            },
            loadState() {
                const stateTxt = sessionStorage.getItem(this.storageKey);
                if (stateTxt && stateTxt > "") {
                    try {
                        const state = JSON.parse(stateTxt);
                        return Promise.resolve(state);
                    } catch (e) {
                        console.error("Error parsing state:", e);
                        return Promise.resolve(null);
                    }
                } else {
                    return Promise.resolve(null);
                }
            },
            saveState(state) {
                console.log("saveState");
                if (state) {
                    try {
                        sessionStorage.setItem(this.storageKey, JSON.stringify(state));
                    } catch (e) {
                        console.error("Error saving state:", e);
                    }
                }
            },
        },
    };
</script>

<style scoped>
   
    .naHeader {
        display: flex;
        flex-direction: column;
        padding-bottom: 20px;
    }

    .naTopControls {
        display: flex;
        justify-content: right;
        gap: 20px;
        align-items: center;
    }

    .na-FilterCell {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    .widget-footer {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #eee;
    }


    .title-cell:hover {
        cursor: pointer;
        text-decoration: underline !important;
    }

    .colKey:hover {
        cursor: pointer;
        text-decoration: underline;
    }
</style>

<style>
    .naGrid .dx-datagrid tr td.actionColumn {
        padding-left: 0;
    }

    .naGrid .dx-datagrid {
        border-radius: 4px;
        overflow: hidden;
    }
    .dx-switch-container .dx-switch-inner .dx-switch-handle::before {
        background-color: #b3b3b3
    }

    .dx-switch-on-value .dx-switch-container .dx-switch-inner .dx-switch-handle::before {
        background-color: #4799e2
    }
</style>
